import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Col, Container, Row } from 'react-bootstrap'
import Navigation from '../../components/navigation/Navigation'
import Footer from '../../components/footer/Footer'
import Banner from '../../components/banner/banner'
import SEO from '../../components/seo/SEO'
import { EXPERTISEBG } from '../../assets/images'
import blogPosts from '../../components/blog_files/blogs-data.json'
import './blog.css'

const Blog = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <SEO
        title="Blog"
        description="Insights on Agentic AI, digital transformation, and enterprise technology from the Triumphal team."
        path="/blog"
        keywords="Triumphal blog, Agentic AI insights, digital transformation blog"
      />
      <Navigation />
      <Banner title="Blog" bg={EXPERTISEBG} />
      <Container className="mt-75 mb-75">
        {blogPosts.length === 0 ? (
          <p className="text-center">No blog posts yet. Check back soon.</p>
        ) : (
          <Row>
            {blogPosts.map((post) => (
              <Col lg="4" md="6" sm="12" key={post.slug} className="mb-4">
                <Link to={`/blog/${post.slug}`} className="blog_card">
                  {post.overviewImage && (
                    <div className="blog_card_image">
                      <img src={post.overviewImage} alt={post.title} />
                    </div>
                  )}
                  <div className="blog_card_body">
                    <p className="blog_mono">
                      {post.category && (
                        <span className="blog_card_category">{post.category}</span>
                      )}
                      {post.category && post.date && <span className="blog_card_slash"> / </span>}
                      {post.date && <span>{post.date}</span>}
                    </p>
                    <h3 className="blog_card_title">{post.title}</h3>
                    {post.description && (
                      <p className="blog_card_description">{post.description}</p>
                    )}
                    <div className="blog_card_footer">
                      <span className="blog_avatar">
                        {(post.author || '?').trim().charAt(0).toUpperCase()}
                      </span>
                      <span className="blog_card_author">
                        <strong>{post.author}</strong>
                        <span className="blog_mono">{post.readTime}</span>
                      </span>
                    </div>
                    <span className="blog_card_read_more">Read more →</span>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        )}
      </Container>
      <Footer />
    </>
  )
}

export default Blog
